module.exports = __webpack_public_path__ + "static/media/MontagneRusse.66864cb4.jpg";